import YunJieChartSimple from "./src/components/charts/simple.vue";
import YunJieChartMulticurve from "./src/components/charts/multicurve.vue";
import YunJieChartSpectrum from "./src/components/charts/spectrum.vue";
import YunJieChartPie from "./src/components/charts/pie.vue";
import YunJieChartWaterDrop from "./src/components/charts/waterDrop.vue";
import YunJieChartThermometerE from "./src/components/charts/thermometerE.vue";
import YunJieChartThermometerH from "./src/components/charts/thermometerH.vue";
import YunJieChartGradienter from "./src/components/charts/gradienter.vue";
import YunJieChartBattery from "./src/components/charts/battery.vue";
import YunJieChartDashboard from "./src/components/charts/dashboard.vue";
import YunJieChartAtmos from "./src/components/charts/atmos.vue";
import YunJieChartWind from "./src/components/charts/wind.vue";
import YunJieChartWindCompass from "./src/components/charts/windCompass.vue";
import YunJieChartDomeSettlement from "./src/components/charts/domeSettlement.vue";
import YunJieChartMovingPoint from "./src/components/charts/movingPoint.vue";

const components = [
  YunJieChartSimple,
  YunJieChartMulticurve,
  YunJieChartSpectrum,
  YunJieChartPie,
  YunJieChartWaterDrop,
  YunJieChartThermometerE,
  YunJieChartThermometerH,
  YunJieChartGradienter,
  YunJieChartBattery,
  YunJieChartDashboard,
  YunJieChartAtmos,
  YunJieChartWind,
  YunJieChartWindCompass,
  YunJieChartDomeSettlement,
  YunJieChartMovingPoint
];

const install = function (Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component)
  });

  Vue.prototype.$YunJie = {
    theme: opts.theme || "standard"
  };
}

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  YunJieChartSimple,
  YunJieChartMulticurve,
  YunJieChartSpectrum,
  YunJieChartPie,
  YunJieChartWaterDrop,
  YunJieChartThermometerE,
  YunJieChartThermometerH,
  YunJieChartGradienter,
  YunJieChartBattery,
  YunJieChartDashboard,
  YunJieChartAtmos,
  YunJieChartWind,
  YunJieChartWindCompass,
  YunJieChartDomeSettlement,
  YunJieChartMovingPoint
}


// WEBPACK FOOTER //
// ./index.js